import {
  Flex,
  Paper,
  Space,
} from '@mantine/core';
import {
  Outlet,
} from '@tanstack/react-router';
import React from 'react';

import styles from '#components/layouts/TabLayout.module.scss';

export interface TabLayoutProps {
}

export function TabLayout(props: TabLayoutProps): React.JSX.Element {
  return (
    <>
      <Paper
        className={ styles.contentContainer }
        shadow="xl"
        radius="xl"
        px={ {
          base: 'xs',
          md: 'lg',
        } }
        pb="lg"
        pt="lg"
        mx={ {
          base: 'xs',
          md: 'lg',
        } }
        mb="xl"
        mih="100%"
        h="100%"
      >
        <Flex
          className={ styles.layoutFlex }
          direction="column"
          justify="flex-start"
          align="stretch"
          gap={ {
            base: 'sm',
            md: 'xl',
          } }
        >
          <Outlet></Outlet>
        </Flex>
      </Paper>
      <Space
        h="lg"
      />
    </>
  );
}

export default TabLayout;
